import { useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import Toolbar from '@mui/material/Toolbar';
import Navigation from 'components/Layout/Navigation';
import { routes } from 'plugins/router';

const NavigationBar = (): JSX.Element => {
  const { zIndex } = useTheme();

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          zIndex: zIndex.modal - 100,
          position: 'relative',
        }}
      >
        <AppBar
          position="static"
          color="default"
          sx={{
            boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.04)',
            backgroundColor: 'white',
          }}
        >
          <Toolbar
            sx={{
              minHeight: 'auto !important',
              maxHeight: 'auto !important',
              padding: '0px',
              overflow: 'hidden',
            }}
          >
            <Container
              sx={{
                maxWidth: 'calc(100% - 200px) !important',
                p: '0 !important',
              }}
            >
              <Box display="flex">
                <List
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                  }}
                  disablePadding={true}
                >
                  {routes.map((navRoute, key) => (
                    <Navigation
                      navRoute={navRoute}
                      key={`${navRoute.name}-${key}`}
                    />
                  ))}
                </List>
              </Box>
            </Container>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default NavigationBar;
